import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: '[ui-page-footer]',
  styleUrls: ['./footer.scss'],
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None,
})
export class UiFooter { }
